<template>
  <div>
    <div class="split-box">
      <div class="split-line"></div>
      <div class="split-name">【报名状态修改】</div>
    </div>
    <div class="row">
      <div class="psuList">
        <div class="item" v-for="item in psuList" :key="item.psuid">
          <div class="comfullname">
            {{ item.psucomfullname }}
          </div>
          <div class="psustatus">
            {{ item.psustatus | psuStatus }}
          </div>
          <div class="btn">
            <el-button type="primary" size="mini" round @click="clipClick(item)"
              >修改</el-button
            >
          </div>
        </div>
      </div>
    </div>
    <el-dialog title="修改状态" :visible.sync="dialogchangeStatus" width="50%">
      <RegistrationStatus
        :psuInfo="psuInfo"
        :appends="appends"
        @reloadStatus="reloadStatus"
      />
    </el-dialog>
  </div>
</template>

<script>
import request from "@/utils/request";

import RegistrationStatus from "./RegistrationStatus.vue";
export default {
  name: "RegistrationList",
  components: { RegistrationStatus },
  data() {
    return {
      dialogchangeStatus: false,
      psuList: [],
      appends: {},
      psuInfo: {},
    };
  },
  props: {
    projectid: Number,
  },
  async activated() {
    await this.getPsuList();
  },
  filters: {
    psuStatus(e) {
      // 待审1，驳回2，通过3，拒绝4
      switch (Number(e)) {
        case 1:
          e = "待审";
          break;
        case 2:
          e = "驳回";
          break;
        case 3:
          e = "通过";
          break;
        case 4:
          e = "拒绝";
          break;
      }
      return e;
    },
  },
  methods: {
    async getPsuList() {
      let res = await request({
        method: "get",
        url: "/xmgl/project/getPsuInfoByProjectId",
        params: {
          projectid: this.projectid,
          cosid: this.$store.getters.loginUser.cosid,
          total: 0,
          limit: 20,
          offset: 0,
        },
      });
      this.psuList = res.list;
    },
    async clipClick(item) {
      this.appends = await this.getAppend(item);
      this.psuInfo = item;
      this.dialogchangeStatus = true;
    },
    async reloadStatus() {
      await this.getPsuList();
      this.dialogchangeStatus = false;
    },
    async getAppend(e) {
      let res = await request({
        method: "get",
        url: "ywgl/append/getAppendListByFromId",
        params: { appendfromid: e.psuid, appendfromtype: 21 },
      });
      return res[0];
    },
  },
};
</script>

<style lang="scss" scoped>
.split-box {
  margin: 11px 0 15px;
  .split-line {
    margin: 5px;
  }
  .split-name {
    font-weight: bold;
  }
}
.psuList {
  text-align: center;
  .item {
    display: flex;
    border-left: 1px solid #000;
    border-right: 1px solid #000;
    border-bottom: 1px solid #000;
    &:first-child {
      border-top: 1px solid #000;
    }
    padding: 5px;
    div {
      flex: 1;
    }
  }
}
.lab {
  width: 90px;
  text-align: right;
}
.val {
}
</style>
